import { Image } from '@/types';

import CallToActionContainer, { CallToActionContainerProps } from '@/components/common/callToAction/CallToActionContainer';

type EmptyStateProps = {
  illustration?: Image;
  title: string;
  paragraph: string;
  button?: CallToActionContainerProps;
}

import styles from './EmptyState.module.scss';

const EmptyState = ({ illustration, title, paragraph, button }: EmptyStateProps): React.JSX.Element => {
  return (
    <div className={styles.container}>
      {illustration && <img src={illustration.url} alt={illustration.alt} />}
      <div className={styles.content}>
        <span className={styles.title}>{title}</span>
        <span data-test-id="paragraph" className={styles.paragraph}>{paragraph}</span>
        {button && <CallToActionContainer {...button} />}
      </div>
    </div>
  );
};

export default EmptyState;
